export const faqs = [
  {
    q: 'Does it work for any group level?',
    a: 'Yes. Every session includes Version A for beginners, Version B for intermediate and Version C for advanced. You can teach the same class to a mixed group with no problem.',
  },
  {
    q: 'What currency do I pay in?',
    a: "The price is in US dollars. If you're outside the US, you're charged in your local currency — the conversion happens automatically at checkout. No dollar account needed.",
  },
  {
    q: 'How do I receive the material?',
    a: 'Instant access within 5 minutes. After paying, you get an email with your personal link. Download all 6 Volumes as PDFs — the files are yours FOREVER. Print them or use them straight from your phone, tablet or computer.',
  },
  {
    q: 'Do I need special equipment?',
    a: "NO — basic equipment only. Sessions use barbells, dumbbells, kettlebells, plyo boxes, TRX and mats. If your gym has the basics, YOU'RE SET.",
  },
  {
    q: "Does it work if I'm a gym instructor and not a PE teacher?",
    a: "YES — 70% of our customers are gym instructors. Functional Fitness 365 is built for PE teachers, gym instructors, CrossFit coaches, personal trainers and strength & conditioning coaches.",
  },
  {
    q: 'Is the guarantee real?',
    a: "100% real — no forms, no hassle. Buy today and if you don't love it within 7 days, send us an email and we'll refund your money. We won't ask why. Fewer than 2% ever request a refund.",
  },
  {
    q: "I'm a beginner — do I need programming knowledge?",
    a: "NO. You don't need to know periodization or advanced theory. Every session is ALREADY built with the objective, exercises and sets. Open, read, teach. It works for new and experienced coaches alike — 40% of our customers are coaches just starting out.",
  },
  {
    q: 'Can I use it with more than one group?',
    a: 'YES — unlimited use with all your groups. One payment = lifetime access. Use it with 1 group, 5 groups or 20 groups. No restrictions.',
  },
]
